export function RectangleTasksIcon(props: Readonly<React.SVGProps<SVGSVGElement>>): JSX.Element {
  return (
    <svg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x='0.75' y='0.75' width='13.5' height='8.5' rx='1.25' stroke='currentColor' strokeWidth='1.5' />
      <path
        d='M13.4164 9.5V10.917C13.4162 11.6072 12.8566 12.167 12.1664 12.167H2.83334C2.1431 12.167 1.58352 11.6072 1.58334 10.917V9.5H13.4164Z'
        stroke='currentColor'
        strokeWidth='1.5'
      />
      <path
        d='M12.5836 12.4166V13.8336C12.5835 14.5237 12.0237 15.0834 11.3336 15.0836H3.66666C2.97641 15.0836 2.41683 14.5238 2.41666 13.8336V12.4166H12.5836Z'
        stroke='currentColor'
        strokeWidth='1.5'
      />
    </svg>
  )
}
